import type { DocumentType } from 'state/__generated__/tadaahAPI';
import { useApiDocumentTypesList } from 'state/__generated__/tadaahAPI';
import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';

type Option = {
  label: string;
  value: string;
};

type UseGetDocumentTypesHandler = {
  data: Option[];
  error: Error | null;
  isLoading: boolean;
};

const useGetDiplomaTypes = (): UseGetDocumentTypesHandler => {
  const isLoggedIn = useIsFreelancerLoggedIn();

  const { data, error, isLoading } = useApiDocumentTypesList({
    query: {
      enabled: isLoggedIn,
      queryKey: 'document-types',
    },
  });

  let diplomasTypes: DocumentType[] = [];
  if (data?.data && data?.data.length)
    diplomasTypes = data.data
      .filter((dtype) => dtype.is_diploma && !dtype.is_certificate)
      .sort((dtype1, dtype2) => {
        if (dtype1.name > dtype2.name) return 1;
        return -1;
      });

  const diplomaOptions = [] as Option[];
  diplomasTypes.map((item) =>
    diplomaOptions.push({
      label: item.name,
      value: item.id?.toString() || '',
    }),
  );

  return { data: diplomaOptions, error, isLoading };
};

export default useGetDiplomaTypes;
